G.MatchList = function() {

	this.list = [];

};

G.MatchList.prototype.push = function(array) {
	
	for (var i = 0, len = this.list.length; i < len; i++) {
		if (this.list[i][0] == array[0] && this.list[i][1] == array[1]) return;
	}	
	this.list.push(array);

};

G.MatchList.prototype.remove = function(array) {

	for (var i = 0, len = this.list.length; i < len; i++) {
		if (this.list[i][0] == array[0] && this.list[i][1] == array[1]) {
			this.list.splice(i,1);
			return;
		}
	}	

};

G.MatchList.prototype.addHorizontal = function(cellFrom,cellTo,cellY) {
	for ( ; cellFrom <= cellTo; cellFrom++) {
		this.push([cellFrom,cellY]);
	}
};

G.MatchList.prototype.addVertical = function(cellX,cellFrom,cellTo) {
	for ( ; cellFrom >= cellTo; cellFrom--) {
		this.push([cellX,cellFrom]);
	}
};

G.MatchList.prototype.loop = function(func,context) {

	for (var i = 0, len = this.list.length; i < len; i++) {
		func.call(context || this, this.list[i]);
	}	

};